import * as brandActionTypes  from '../_actionTypes/brand';

export const brandReducer = (state = [], action) => {
    switch(action.type){
      case brandActionTypes.GET:
        return state = action.brands
      default:
        return state
    }
}